export default __webpack_public_path__ + "static/media/category2.6c41a0cc.svg";